import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { DownloadButtonProps } from '../types';

const DownloadButton = ({ url }: DownloadButtonProps) => {
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const extensionCandidate = url.split('.').pop();
      const extension = extensionCandidate ? extensionCandidate.split('?')[0] : 'png';
      const filename = `ai-image.${extension || 'png'}`;
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(blob);
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(anchor.href);
    } catch {
      // Intentionally silent to avoid interrupting the chat flow on download failures.
    }

    setDownloading(false);
  };

  return (
    <button
      type="button"
      className="message-copy-btn"
      onClick={handleDownload}
      disabled={downloading}
      title={t('assistant.downloadImage')}
    >
      <i className={`ti ${downloading ? 'ti-loader-2 spin' : 'ti-download'}`} />
    </button>
  );
};

export default DownloadButton;
